import { render, staticRenderFns } from "./ArchivoAspirantes.vue?vue&type=template&id=7b5ef08f&scoped=true"
import script from "./ArchivoAspirantes.vue?vue&type=script&lang=js"
export * from "./ArchivoAspirantes.vue?vue&type=script&lang=js"
import style0 from "./ArchivoAspirantes.vue?vue&type=style&index=0&id=7b5ef08f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ef08f",
  null
  
)

export default component.exports